module.exports = __webpack_public_path__ + "62a51f311511ff63cec5baa39632b1fe.png";